import { YStack } from "tamagui";
const Header = ({
  children,
  type = "default",
  collapsed = false,
}: Readonly<{ children?: React.ReactNode; type?: "default" | "welcome"; collapsed?: boolean }>) => {
  const styleWrap = (type: string) => {
    switch (type) {
      case "welcome":
        return { height: "100dvh" };

      default:
        return {};
    }
  };

  const pad = type === "default" && collapsed ? 12 : 20;
  return (
    <YStack
      className="app-header-gradient"
      px={20}
      pt={pad}
      pb={pad}
      borderRadius={type === "default" ? 30 : 0}
      btrr={0}
      btlr={0}
      style={{ transition: "padding 0.28s ease", ...styleWrap(type) }}>
      {children}
    </YStack>
  );
};

export default Header;
